import React from 'react';
import { styled } from '@stitches/react';
import { MarketingFooter } from './Footer';
import { MarketingNav } from './MarketingNav';

const PageContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  justifyContent: 'space-between',
  backgroundColor: '$lupine-50',
  width: '100%',
});

const MainContent = styled('main', {
  margin: 'auto',
  width: '100%',
  position: 'relative',
});

export const MarketingPage = ({ children }) => {
  return (
    <>
      <PageContainer>
        <MarketingNav />
        <MainContent>{children}</MainContent>
        <MarketingFooter />
      </PageContainer>
    </>
  );
};
